/**
 * Shared matcher for the Drivers page Local/OTR ("Preference") filter.
 *
 * The filter values come from safetynew.driver.preference ('LOCAL' / 'OTR'),
 * which is also what the Planning tab renders as the driver's LOCAL/OTR badge.
 * Comparison is case-insensitive so that persisted filter settings written
 * before the option value became upper-case ('Local') keep working, and so a
 * stray lower-case DB value still matches.
 *
 * An empty selection means "All" — every driver matches. A driver with no
 * preference on file matches nothing once a type is selected.
 */
export function matchesDriverPreference(
  preference: string | null | undefined,
  selectedTypes: string[]
): boolean {
  if (selectedTypes.length === 0) return true;
  const driverPreference = (preference || '').trim().toLowerCase();
  if (!driverPreference) return false;
  return selectedTypes.some(type => type.trim().toLowerCase() === driverPreference);
}
